import Link from 'components/link';

export const TileLink = Link;

export const TileLinkExternal = Link.withConfig({ isExternal: true });

export default TileLink;
